<template>
  <div>
    <ag-review-carousel
    ></ag-review-carousel>
    <ag-loading v-if="loading"></ag-loading>
    <iframe
      v-show="!loading"
      id="iframe"
      width="100%"
      :src="source"
      frameborder="0"
      @load="iframeLoaded()"
    ></iframe>
  </div>
</template>

<script>
import { computed, defineComponent, reactive, ref } from "vue";
import iFrameResize from "iframe-resizer/js/iframeResizer";
import { useStore } from "@/store";
import { AuthActionTypes } from "../../store/modules/auth/action-types";
import { GeneralActionTypes } from "../../store/modules/general/action-types";
import AgLoading from "@/components/ag-loading/index.vue";
import { mapState, mapGetters } from "vuex";
import { Roles } from "@/helpers/enums/Roles";
import AgReviewCarousel from "@/components/ag-review-carousel/index.vue";

export default defineComponent({
  name: "ag-iframe",
  props: {
    loading: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      progress: false,
      Roles: Roles,
    };
  },
  components: {
    AgLoading,
    AgReviewCarousel,
  },
  setup() {
    const store = useStore();
    const company = computed(() => store.getters.company);

    const setCompany = (item) => {
      store.dispatch(AuthActionTypes.SET_COMPANY, {
        ...item,
        selected: true,
        agms: true,
      });
    };

    const setLoader = (status) => {
      store.dispatch(GeneralActionTypes.LOADER_STATUS, status);
    };

    return {
      setCompany,
      company,
      setLoader,
    };
  },
  computed: {
    ...mapState({
      agmsGroup: (state) => state.auth.agmsGroup,
      agmsSite: (state) => state.auth.agmsSite,
      agmsTemplate: (state) => state.auth.agmsTemplate,
      site: (state) => state.auth.site,
    }),
    ...mapGetters(["loggedInUser", "partner"]),
    source() {
      const url = this.$route.meta.target;
      const parent = this.$route.meta.parent;

      if (
        this.agmsTemplate &&
        this.agmsTemplate.mainid &&
        this.agmsTemplate.templateType == 2 &&
        this.$route.meta.title == "defaultEnclave"
      ) {
        return (
          process.env.VUE_APP_AGMS_URL +
          `/LinuxPolicy/LinuxTemplatePolicy/Spaces?mainId=${this.agmsTemplate.mainid}&type=Template&policytypeId=10`
        );
      }
      if (this.$route.meta.title == "groupList") {
        if (this.site.mainId || this.site.mainid) {
          return (
            process.env.VUE_APP_AGMS_URL +
            `/AppGuardMain/Site/GroupList?mainId=${
              this.site.mainId ? this.site.mainId : this.site.mainid
            }&type=Site`
          );
        } else {
          var site = JSON.parse(localStorage.getItem("agms_site"));
          return (
            process.env.VUE_APP_AGMS_URL +
            `/AppGuardMain/Site/GroupList?mainId=${site.mainId}&type=Site`
          );
        }
      }
      var urlReplaced = url.replace("$policySubmenu", this.policyUrl(parent));

      let partnerParam = '';
      if(localStorage.getItem('realRole') === Roles.AGMSAdmin && this.loggedInUser.role === Roles.PartnerAdmin) {
        if(this.paramsByRole(parent)) {
          partnerParam = `?partnerId=${this.partner.guid}`
        }else {
          partnerParam = `&partnerId=${this.partner.guid}`
        }
      }
      return urlReplaced.replace("$paramsByRole", this.paramsByRole(parent)) + partnerParam;
    },
  },
  methods: {
    iframeLoaded() {
      let elData = this.$data;
      let setLoader = this.setLoader;
      let company = this.company;
      let setCompany = this.setCompany;
      iFrameResize(
        {
          log: false,
          inPageLinks: true,
          onInit: function (iframe) {
            elData.progress = false;
            setTimeout(setLoader(true), 500);
            if (!company.agms) {
              iframe.iFrameResizer.sendMessage({
                companyId: company.companyGuid,
              });
            }
          },
          onMessage: function (message) {
            /*Selected Company*/
            elData.progress = true;
            setLoader(false);
            if (message.message.companySelection) {
              setCompany(company);
            }
          },
        },
        "#iframe"
      );
    },
    policyUrl(parent) {
      if (!this.loggedInUser && !this.loggedInUser.role) return "";
      if (parent && parent === "policy") {
        if (
          [Roles.AGMSAdmin, Roles.PartnerAdmin, Roles.CompanyAdmin].includes(this.loggedInUser.role)
        ) {
          if (this.agmsTemplate && this.agmsTemplate.mainid)
            return `TemplatePolicy`;
          else return `GroupPolicy`;
        }
        if (
          [Roles.SiteAdmin, Roles.GroupAdmin].includes(this.loggedInUser.role)
        )
          return `GroupPolicy`;
      }
    },
    paramsByRole(parent) {
      if (this.$route.query.mainId) {
        return `mainId=${this.$route.query.mainId}`;
      }
      if (!this.loggedInUser && !this.loggedInUser.role) return "";
      if (parent && parent === "policy") {
        if (
          [Roles.AGMSAdmin, Roles.PartnerAdmin, Roles.CompanyAdmin].includes(this.loggedInUser.role)
        ) {
          if (this.agmsTemplate && this.agmsTemplate.mainid)
            return `mainId=${this.agmsTemplate.mainid}&type=Template`;
          else return `mainId=${this.agmsGroup.mainid}&type=Group`;
        }
        if (
          [Roles.SiteAdmin, Roles.GroupAdmin].includes(this.loggedInUser.role)
        )
          return `mainId=${this.agmsGroup.mainid}&type=Group`;
      } else {
        if (
          [Roles.AGMSAdmin, Roles.PartnerAdmin, Roles.CompanyAdmin].includes(this.loggedInUser.role)
        ) {
          if (this.agmsGroup.mainid)
            return `mainId=${this.agmsGroup.mainid}&type=Group`;
          if (this.agmsSite.mainid)
            return `mainId=${this.agmsSite.mainid}&type=Site`;
          return "mainId=0&type=Sys";
        }

        if (Roles.SiteAdmin == this.loggedInUser.role)
          return `mainId=${this.agmsSite.mainid}&type=Site`;
        if (Roles.GroupAdmin == this.loggedInUser.role)
          return `mainId=${this.agmsGroup.mainid}&type=Group`;
      }
    },
  },
});
</script>

<style scoped lang="scss">
iframe {
  overflow: auto !important;
  display: block !important;
  min-height: 100vh !important;
  margin-bottom: 25px;
}
</style>
